import * as XLSX from 'xlsx';

const downloadExcelHandler = (data) => {
  let wb = XLSX.utils.book_new();
  let ws = XLSX.utils.json_to_sheet(data);
  XLSX.utils.book_append_sheet(wb, ws, 'Hoja1');
  XLSX.writeFile(wb, 'RESUMEN_SIPTEL.xlsx');
};
export default downloadExcelHandler;
